<template lang="pug">
  footer.footer
    div.container
      div.footer__wrapper
        div.footer-left
          p © Copyright {{ new Date().getFullYear() }}, All Rights Reserved
          div.footer-left__wrapper
            router-link(:to="{ path: '/privacy-policy', hash: '#terms-privacy' }") Privacy Policy
            router-link(:to="{ path: '/terms-conditions', hash: '#terms-privacy' }") Terms of USE
        div.footer-right
          router-link(:to="{ path: '/', hash: '#hero' }")
            img(:src="Logo" alt="logo")
</template>

<script>
import Logo from '@/assets/images/avalon.svg'

export default {
  name: 'FooterBlock',
  data () {
    return {
      Logo
    }
  }
}
</script>
